const config = {
  apiGateways: {
    BASE_URL_1: process.env.REACT_APP_BACKEND_URL_HTTP
  },
  SOCKET_URL: process.env.REACT_APP_BACKEND_URL_WS,
  API_ENCRYPTION_KEY: process.env.REACT_APP_API_ENCRYPTION_KEY,
  OPERATOR_CALLBACK_BASE_URL: process.env.REACT_APP_OPERATOR_BASE_URL
}

export default config
